
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.675',
  depVersions: {
  "portals-platform-reference-fe": "static-1.675",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.442",
  "foundations-assets": "static-1.4538",
  "foundations-theming": "static-1.4112",
  "foundations-theming-base": "static-1.3097",
  "foundations-theming-specialty": "static-1.1828",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7690",
  "hub-http-shared-msw-handlers": "static-1.9232",
  "hubspot-dlb": "static-2.1773",
  "react-dlb": "static-1.70",
  "data-fetching-client": "static-1.9382",
  "enviro": "static-4.387",
  "foundations-components": "static-1.7329",
  "history": "static-4.47",
  "hub-http": "static-1.5872",
  "HubStyleTokens": "static-2.11131",
  "I18n": "static-7.1542",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.435",
  "quartz-config": "static-1.369",
  "quartz-core": "static-1.5810",
  "quick-fetch": "static-1.3644",
  "react": "static-7.176",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16339",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4312",
  "ui-addon-react-router-dom": "static-1.9254",
  "UIComponents": "static-3.8078",
  "usage-tracker": "static-1.7043",
  "usage-tracker-anonymous": "static-1.5460",
  "usage-tracker-core": "static-1.6893",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3825",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9296",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "styled-components": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3143",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2868",
  "quartz-webpack": "static-1.2815",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.2595",
  "framer-motion": "static-1.66",
  "hs-story-utils": "static-1.9134",
  "react-utils": "static-2.5091",
  "StyleGuideUI": "static-3.482",
  "stylex": "static-1.26",
  "HeadJS": "static-2.691",
  "quartz": "static-1.6591",
  "hs-test-utils-bend-plugin": "static-1.2801",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3819",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "bend-plugin-foundations-components": "static-1.3598",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.990",
  "ui-fonts": "static-1.393",
  "ui-images": "static-2.1063",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.771",
  "hubspotter-http": "static-1.4393",
  "icons": "static-2.614",
  "jasmine": "static-4.4037",
  "jasmine-runner": "static-1.6161",
  "mobile-manifest-mixins": "static-1.464",
  "quartz-auth": "static-1.266",
  "quartz-head": "static-1.256",
  "quartz-i18n": "static-1.266",
  "quartz-test": "static-1.266",
  "usage-tracker-container": "static-1.7033",
  "csstype": "static-1.50",
  "cssUtils": "static-1.699",
  "HubStyle": "static-2.11439",
  "bender-build-tools": "static-1.2823",
  "react-input-autosize": "static-2.17",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9230"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.675",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.442",
  "foundations-assets": "/foundations-assets/static-1.4538",
  "foundations-theming": "/foundations-theming/static-1.4112",
  "foundations-theming-base": "/foundations-theming-base/static-1.3097",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1828",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7690",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9232",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "react-dlb": "/react-dlb/static-1.70",
  "data-fetching-client": "/data-fetching-client/static-1.9382",
  "enviro": "/enviro/static-4.387",
  "foundations-components": "/foundations-components/static-1.7329",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5872",
  "HubStyleTokens": "/HubStyleTokens/static-2.11131",
  "I18n": "/I18n/static-7.1542",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.435",
  "quartz-config": "/quartz-config/static-1.369",
  "quartz-core": "/quartz-core/static-1.5810",
  "quick-fetch": "/quick-fetch/static-1.3644",
  "react": "/react/static-7.176",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16339",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4312",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9254",
  "UIComponents": "/UIComponents/static-3.8078",
  "usage-tracker": "/usage-tracker/static-1.7043",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5460",
  "usage-tracker-core": "/usage-tracker-core/static-1.6893",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9296",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3143",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2868",
  "quartz-webpack": "/quartz-webpack/static-1.2815",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2595",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9134",
  "react-utils": "/react-utils/static-2.5091",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "stylex": "/stylex/static-1.26",
  "HeadJS": "/HeadJS/static-2.691",
  "quartz": "/quartz/static-1.6591",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2801",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3819",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3598",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.990",
  "ui-fonts": "/ui-fonts/static-1.393",
  "ui-images": "/ui-images/static-2.1063",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.771",
  "hubspotter-http": "/hubspotter-http/static-1.4393",
  "icons": "/icons/static-2.614",
  "jasmine": "/jasmine/static-4.4037",
  "jasmine-runner": "/jasmine-runner/static-1.6161",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.464",
  "quartz-auth": "/quartz-auth/static-1.266",
  "quartz-head": "/quartz-head/static-1.256",
  "quartz-i18n": "/quartz-i18n/static-1.266",
  "quartz-test": "/quartz-test/static-1.266",
  "usage-tracker-container": "/usage-tracker-container/static-1.7033",
  "csstype": "/csstype/static-1.50",
  "cssUtils": "/cssUtils/static-1.699",
  "HubStyle": "/HubStyle/static-2.11439",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9230"
}
};
